import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PasswordInput from "../../components/PasswordInput";
import "../../styles/admin.css";

const API_BASE_URL = "/api";

function AdminResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");
    setError("");

    if (!token) {
      setError("لینک بازیابی رمز عبور معتبر نیست.");
      return;
    }

    if (!password || !confirmPassword) {
      setError("رمز عبور و تکرار رمز عبور الزامی هستند.");
      return;
    }

    if (password.length < 6) {
      setError("رمز عبور باید حداقل ۶ کاراکتر باشد.");
      return;
    }

    if (password !== confirmPassword) {
      setError("رمز عبور و تکرار آن یکسان نیستند.");
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(
        `${API_BASE_URL}/staff/reset-password/${token}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            password,
            confirmPassword,
          }),
        }
      );

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        setError(data.message || "خطا در تغییر رمز عبور.");
        return;
      }

      setIsSuccess(true);
      setMessage(data.message || "رمز عبور با موفقیت تغییر کرد.");
      setPassword("");
      setConfirmPassword("");
    } catch (err) {
      console.error("Reset password request error:", err);
      setError("ارتباط با سرور برقرار نشد.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-reset-page">
      <div className="admin-reset-card">
        <div className="admin-reset-header">
          <span className="admin-badge">پنل مدیریت</span>
          <h2>تنظیم رمز عبور جدید</h2>
          <p>رمز عبور جدید حساب مدیریتی خود را وارد کنید.</p>
        </div>

        {error && <div className="auth-error">{error}</div>}
        {message && <div className="auth-success">{message}</div>}

        {!isSuccess ? (
          <form onSubmit={handleSubmit}>
            <div className="admin-field">
              <label>رمز عبور جدید</label>
              <PasswordInput
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="حداقل ۶ کاراکتر"
                required
                autoComplete="new-password"
              />
            </div>

            <div className="admin-field">
              <label>تکرار رمز عبور جدید</label>
              <PasswordInput
                name="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="تکرار رمز عبور جدید"
                required
                autoComplete="new-password"
              />
            </div>

            <button
              type="submit"
              className="admin-submit-btn"
              disabled={loading}
            >
              {loading ? "در حال ثبت..." : "ثبت رمز عبور جدید"}
            </button>
          </form>
        ) : (
          <button
            type="button"
            className="admin-submit-btn"
            onClick={() => navigate("/admin/login")}
          >
            بازگشت به صفحه ورود ادمین
          </button>
        )}
      </div>
    </div>
  );
}

export default AdminResetPassword;
